import { render, staticRenderFns } from "./TifJustificacionesIndex.vue?vue&type=template&id=23ea1330"
import script from "./TifJustificacionesIndex.vue?vue&type=script&lang=js"
export * from "./TifJustificacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports